import React from 'react';
import { compose, withProps, lifecycle, withState, withHandlers } from 'recompose';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import { get } from 'lodash';
import { getAttributeValue, updateAttributeValue } from '../attributes/_api';
import withLoader from '../app/withLoader';
import EditForm from './form/addValueForm';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withProps(({ match: { params: { attributeId, id } } }) => ({
    attributeId,
    id,
  })),
  withState('attributeValue', 'setAttributeValue', null),
  withHandlers({
    loadItem: ({ toggleLoader, setAttributeValue, id }) => async () => {
      toggleLoader();
      const resp = await getAttributeValue(id);
      if (resp) {
        setAttributeValue(resp);
      }
      toggleLoader(false);
    },
  }),
  lifecycle({
    async componentDidMount() {
      const { loadItem } = this.props;
      loadItem();
    },
  }),
  withHandlers({
    onSubmit: ({ attributeId, setEdit, loadItem, history, enqueueSnackbar }) => async values => {
      const resp = await updateAttributeValue(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Hodnota atributy byla úspěšně změněna.', { variant: 'success' });
        history.push(`/attributes/${attributeId}`);
      } else {
        enqueueSnackbar('Hodnota atributy se nepodařilo změnit.', { variant: 'error' });
      }
    },
  }),
);

export default enhance(
  ({ classes, attributeValue, values, attributeId, edit, setEdit, onSubmit }) => (
    <div className={classes.root}>
      <h3>Upravit hodnotu atributu</h3>
      <Paper className={classes.paper}>
        {attributeValue && <EditForm initialValues={attributeValue} onSubmit={onSubmit} />}
      </Paper>
    </div>
  ),
);



// WEBPACK FOOTER //
// ./src/modules/attributes/detailValue.js